import React from 'react';
import RouteThumbnailsTree from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsTree';

export default function RouteThumbnailsTreeContainer({
  tree,
  list,
  routeName,
  projectId,
  routeId,
  isStereospecific,
  treeTooltip,
  updateTreeThumbnailDetails,
  openRouteOverviewTreePopup,
  openThumbnailPopup,
}) {
  return (
    <RouteThumbnailsTree
      tree={tree}
      list={list}
      routeName={routeName}
      isStereospecific={isStereospecific}
      onTreeNodeClick={(target, data) => {
        if (data?.isTruncationNode) {
          openThumbnailPopup(tree, routeName, routeId);
        } else if (treeTooltip?.data?.id === data?.id) {
          updateTreeThumbnailDetails();
        } else {
          updateTreeThumbnailDetails(target, data);
        }
      }}
      onZoomClick={(treeList, routeNameZm = routeName) =>
        openRouteOverviewTreePopup({ treeList, routeName: routeNameZm, projectId, routeId })
      }
    />
  );
}
